<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-zhishiku`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_911d999da0__clip0_1270_72408)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 2.625C6.72183 2.625 4.875 4.47183 4.875 6.75C4.875 7.64686 5.16036 8.47485 5.64535 9.15104C5.68487 9.20615 5.72534 9.26222 5.76652 9.31927C6.29546 10.0521 6.94025 10.9455 7.18112 12.0086L7.34908 12.75H10.6509L10.8189 12.0086C11.0597 10.9455 11.7045 10.0521 12.2335 9.31926C12.2747 9.26222 12.3151 9.20615 12.3547 9.15104C12.8396 8.47485 13.125 7.64686 13.125 6.75C13.125 4.47183 11.2782 2.625 9 2.625ZM3.375 6.75C3.375 3.6434 5.8934 1.125 9 1.125C12.1066 1.125 14.625 3.6434 14.625 6.75C14.625 7.97075 14.2353 9.1027 13.5735 10.0253C13.5484 10.0604 13.5233 10.0952 13.4985 10.1298C12.9247 10.9288 12.4526 11.5864 12.2818 12.3401L12.0476 13.3736C11.9315 13.8861 11.476 14.25 10.9505 14.25H7.04954C6.524 14.25 6.06848 13.8861 5.95235 13.3736L5.71819 12.3401C5.54743 11.5864 5.07525 10.9288 4.50148 10.1298C4.47665 10.0952 4.45164 10.0604 4.42645 10.0253C3.76474 9.1027 3.375 7.97075 3.375 6.75ZM11.625 15V16.5H6.375V15H11.625Z"/></g><defs><clipPath id="svg_911d999da0__clip0_1270_72408"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconZhishiku',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
